import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '@/context/CartContext';
import CartDrawer from '@/components/feature/CartDrawer';
import SectionLink from '@/components/feature/SectionLink';

export default function StoreNavbar() {
  const { count } = useCart();
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <>
      <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2.5 flex-shrink-0">
              <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-white text-base"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950 tracking-tight">
                Paticas con Propósito
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors">
                Inicio
              </Link>
              <SectionLink section="catalogo" className="text-sm font-medium text-accent-600">
                Catálogo
              </SectionLink>
              <SectionLink section="testimonios" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors">
                Testimonios
              </SectionLink>
              <Link to="/pedidos" className="text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors">
                Mis pedidos
              </Link>
            </div>

            <button
              type="button"
              onClick={() => setCartOpen(true)}
              className="relative w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="Abrir carrito"
            >
              <i className="ri-shopping-bag-3-line text-foreground-700 text-lg"></i>
              {count > 0 && (
                <span className="absolute -top-0.5 -right-0.5 w-5 h-5 bg-accent-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>
      </nav>
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}